import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.managementService



//新增数据
export function postDimTableInsertAdd(data) {
    return request({
        url: serviceName + `/department/add`,
        method: 'post',
        data: data
    })
}

//修改数据
export function postDimTableUpdate(data) {
    return request({
        url: serviceName + `/dim-table/update`,
        method: 'post',
        data: data
    })
}

//删除数据
export function postDimTableDelete(data) {
    return request({
        url: serviceName + `/dim-table/delete`,
        method: 'post',
        data: data
    })
}

//根据id查询部门
export function getDimTableIDdep(id) {
    return request({
        url: serviceName + `/dim-table/${id}`,
        method: 'get',
    })
}

//根据条件获取所有数据列表
export function getDimTableCharByParam(data) {
    return request({
        url: serviceName + `/department/tree`,
        method: 'get',
    })
}

//根据条件获取所有数据列表
export function getDepartmentList(data) {
    return request({
        url: serviceName + `/department/tree`,
        method: 'get',
    })
}
//修改部门状态
export function postDimTableUpdateStatus(data) {
    return request({
        url: serviceName + `/department/isValid`,
        method: 'post',
        data: data
    })
}
